import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { ReportData } from './MiscModel';
import { misc } from '../../api/Endpoints';

export const useSendReportMutation = (
  options?: Partial<UseMutationOptions<object, Error, ReportData>>,
) => {
  return useMutation({
    ...options,
    mutationFn: (data: ReportData) => {
      return misc.sendReport(data);
    },
  });
};
